import isObject from './isObject.js';

/**
 * Remove undefined properties from objects
 * @param {object} object
 * @returns {object}
 */
export default function removeUndefined(object) {
	if (isObject(object)) {
		return Object.entries(object).filter(([, value]) => {
			return typeof value !== 'undefined';
		}).reduce((previous, [key, value]) => {
			previous[key] = removeUndefined(value); // Call recursively
			return previous;
		}, {});
	} else if (Array.isArray(object)) {
		return object.map((item) => removeUndefined(item));
	} else {
		return object;
	}
}
